import { render, staticRenderFns } from "./commitmentLetter.vue?vue&type=template&id=5d841a35&scoped=true"
import script from "./commitmentLetter.vue?vue&type=script&lang=js"
export * from "./commitmentLetter.vue?vue&type=script&lang=js"
import style0 from "./commitmentLetter.vue?vue&type=style&index=0&id=5d841a35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d841a35",
  null
  
)

export default component.exports